import { h } from 'preact';
import { useEffect } from 'preact/hooks';
import { waitForElm } from '../utils/global-utilities';

const YotpoStars = ({
  currentProduct,
  isProductPage = false,
  isProductQuickView = false,
}) => {
  useEffect(() => {
    try {
      window.yotpo.refreshWidgets();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn('unable to refresh yotpo widgets', error);
    }
  }, [currentProduct])

  if (isProductPage || isProductQuickView) {
    waitForElm(
      `#yotpo-id-${currentProduct?.id.replace('gid://shopify/Product/', '')}`,
    )
      .then((e) => {
        // wrap third party calls in try/catch to prevent JS errors from breaking our site
        try {
          if (window.yotpo?.initWidgets) {
            window.yotpo.initWidgets();
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.warn('error initializing Yotpo review stars', error);
        }

        return e;
      })
      .then((e) => {
        let attempts = 0;
        const interval = setInterval(() => {
          const starsWrapper = e.querySelector('.yotpo.bottomLine .yotpo-display-wrapper');
          const extendedReviews = document.querySelector('#yotpo-reviews-main-widget');
          let starsProductDetailsButton = e.querySelector('.standalone-bottomline .yotpo-bottomline');
          if (
            (starsWrapper && extendedReviews) ||
            (starsWrapper && isProductQuickView && starsProductDetailsButton)
            || attempts > 100) {
            if (
              (starsWrapper && extendedReviews) ||
              (starsWrapper && isProductQuickView && starsProductDetailsButton)
            ) {
              if (!starsProductDetailsButton && starsWrapper) {
                starsWrapper.innerHTML =
                  `<a href="#" data-target-write-first-review>
                  ${window.TMW.Strings.product.writeFirstReview}</a>`;
                starsProductDetailsButton = starsWrapper;
              }
              if (starsProductDetailsButton && !isProductQuickView) starsProductDetailsButton.addEventListener('click', (event) => {
                event.preventDefault();
                if (extendedReviews) {
                  extendedReviews.scrollIntoView({
                    behavior: 'smooth'
                  });
                }
              });
              if (!isProductPage) {
                const reviewsNumber = starsProductDetailsButton.querySelector('a');
                reviewsNumber.removeAttribute('href')
                reviewsNumber.classList.add('no-underline', 'before:content-none', 'after:content-none', 'before:hidden', 'after:hidden')
              }
            }
            clearInterval(interval);
          }

          attempts += 1;
        }, 100);
      });
  }

  return (
    <div
      id={`yotpo-id-${currentProduct?.id.replace('gid://shopify/Product/', '')}`}
      className="yotpo bottomLine min-h-[17.5px]"
      data-product-id={currentProduct?.id.replace('gid://shopify/Product/', '')}
      data-url={`${currentProduct.shopUrl}/products/${currentProduct?.handle}`}
    ></div>
  );
};

export default YotpoStars;